import React, { useState } from 'react';
import {
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import RegularButton from 'components/CustomButtons/Button';
import { Add, Close } from '@material-ui/icons';
import { roundMony } from 'hooks/Pipe';

const defaultNewLine = {
  id: 0,
  Dscription: 'Descuentos obtenidos por pronto pago',
  Account: '77511001',
  price: 0,
  quantity: 0,
  TaxCode: 'IGV',
};

function ConceptDetails(props) {
  const { processing, total } = props;
  const { concepts, setConcepts } = props;
  const { purchConcepts } = props;
  const [lineId, setLineId] = useState(1);
  const [newLine, setNewLine] = useState(defaultNewLine);

  function updateNewLine(field, value) {
    setNewLine((line) => {
      let newLine = { ...line };
      newLine[field] = value;
      return newLine;
    });
  }

  function addNewLine() {
    if (newLine.Dscription === '' || newLine.price === 0) {
      window.alert('Llene todos los campos');
      return;
    }

    setConcepts((concepts) => {
      let newConcepts = [...concepts];
      const selectedConcept = purchConcepts.find((c) => c.Account === newLine.Account);
      
      const lineToAdd = {
        ...newLine,
        Dscription: selectedConcept?.description || '',
        Account: selectedConcept?.Account || '',
      };

      newConcepts.push(lineToAdd);
      return newConcepts;
    });
    setNewLine({ ...defaultNewLine, id: lineId });
    setLineId((id) => id + 1);
    console.log('Agregando línea:', newLine);
  }

  function deleteConcept(line) {
    setConcepts((concepts) => {
      let newConcepts = [...concepts];
      let index = newConcepts.findIndex((item) => item.id === line.id);
      newConcepts.splice(index, 1);
      return newConcepts;
    });
  }

  return (
    <TableContainer component={Paper}>
      <Table style={{ minWidth: 1300 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell width="50" align="center">
              #
            </TableCell>
            <TableCell width="200" align="left">
              Concepto
            </TableCell>
            <TableCell align="left" width="130">
              Impuesto
            </TableCell>
            <TableCell align="left" width="130">
              Precio
            </TableCell>
            <TableCell align="left" width="130">
              Importe
            </TableCell>
            <TableCell align="left" width="130">
              Acciones
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {concepts.map((concept, index) => {
            function updateLine(field, value) {
              setConcepts((concepts) => {
                let newConcepts = [...concepts];
                let index = newConcepts.findIndex((item) => item.id === concept.id);
                newConcepts[index][field] = value;
                return newConcepts;
              });
            }
            return (
              <TableRow key={concept.id}>
                <TableCell width="50" align="center">
                  {index + 1}
                </TableCell>
                <TableCell width="200" align="left">
                  <Select
                    fullWidth
                    value={concept.Account}
                    onChange={(e) => {
                      let Dscription = purchConcepts.find(
                        (concept) => concept.Account === e.target.value,
                      ).Dscription;
                      updateLine('Account', e.target.value);
                      updateLine('Dscription', Dscription);
                    }}
                  >
                    {purchConcepts.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.Account}>
                          {item.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </TableCell>
                <TableCell align="left" width="130">
                  {concept.TaxCode}
                </TableCell>
                <TableCell align="left" width="130">
                  <TextField
                    name="Price"
                    value={concept.price}
                    type="number"
                    inputProps={{ min: 0, step: 0.0001 }}
                    fullWidth
                    onChange={(e) => updateLine('price', e.target.value)}
                    disabled={processing}
                  />
                </TableCell>
                <TableCell align="right">{roundMony(concept.price).toFixed(2)}</TableCell>
                <TableCell align="left" width="130">
                  <RegularButton
                    justIcon
                    round
                    simple
                    color={'danger'}
                    style={{ height: '20px' }}
                    disabled={processing}
                    onClick={() => deleteConcept(concept)}
                  >
                    <Close />
                  </RegularButton>
                </TableCell>
              </TableRow>
            );
          })}

          {/* Agregar nuevo detalle */}
          <TableRow>
            <TableCell width="50" align="center">
              #
            </TableCell>
            <TableCell width="200" align="left">
              <Select
                fullWidth
                value={newLine.Account}
                onChange={(e) => {
                  let Dscription = purchConcepts.find(
                    (concept) => concept.Account === e.target.value,
                  ).Dscription;
                  updateNewLine('Account', e.target.value);
                  updateNewLine('Dscription', Dscription);
                }}
              >
                {purchConcepts.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.Account}>
                      {item.description}
                    </MenuItem>
                  );
                })}
              </Select>
            </TableCell>
            <TableCell align="left" width="130">
              {newLine.TaxCode}
            </TableCell>
            <TableCell align="left" width="130">
              <TextField
                name="Price"
                value={newLine.price}
                type="number"
                inputProps={{ min: 0, step: 0.0001 }}
                fullWidth
                onChange={(e) => updateNewLine('price', e.target.value)}
                disabled={processing}
              />
            </TableCell>
            <TableCell align="right">{roundMony(newLine.price).toFixed(2)}</TableCell>
            <TableCell align="left" width="130">
              <RegularButton
                justIcon
                round
                simple
                color="success"
                style={{ height: '20px' }}
                onClick={addNewLine}
                disabled={processing}
              >
                <Add />
              </RegularButton>
            </TableCell>
          </TableRow>

          {/* Total */}
          <TableRow>
            <TableCell colSpan={4}></TableCell>
            <TableCell>{roundMony(total).toFixed(2)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ConceptDetails;
